import {
  BenchmarkCurvesActionTypes,
  BenchmarkCurvesActionUnion,
  LoadCurves,
  LoadWeeklyCurves
} from './actions';
import { BenchmarkCurveStoreState, BenchmarkCurveData } from './state';

export const initialBenchmarkCurvesState: BenchmarkCurveStoreState = {
  weekly: {
    date: undefined,
    provider: undefined,
    loading: false,
    loaded: false,
    errorCode: undefined,
    error: undefined,
    data: []
  },
  single: {
    date: undefined,
    provider: undefined,
    loading: false,
    loaded: false,
    errorCode: undefined,
    error: undefined,
    data: []
  },
  selectedCurve: undefined
};

function isNewQuery(
  action: LoadCurves | LoadWeeklyCurves,
  state: BenchmarkCurveData
) {
  return (
    action.payload.date !== state.date ||
    action.payload.provider !== state.provider
  );
}

export function benchmarkCurvesReducer(
  state: BenchmarkCurveStoreState = initialBenchmarkCurvesState,
  action: BenchmarkCurvesActionUnion
): BenchmarkCurveStoreState {
  let newQuery;
  switch (action.type) {
    case BenchmarkCurvesActionTypes.LoadCurves:
      newQuery = isNewQuery(action, state.single);
      return {
        ...state,
        single: {
          ...state.single,
          date: action.payload.date,
          provider: action.payload.provider,
          loading: true,
          loaded: newQuery ? false : state.single.loaded,
          data: newQuery ? [] : state.single.data,
          error: undefined,
          errorCode: undefined
        }
      };

    case BenchmarkCurvesActionTypes.LoadWeeklyCurves:
      newQuery = isNewQuery(action, state.weekly);
      return {
        ...state,
        weekly: {
          ...state.weekly,
          date: action.payload.date,
          provider: action.payload.provider,
          loading: true,
          loaded: newQuery ? false : state.weekly.loaded,
          data: newQuery ? [] : state.weekly.data,
          error: undefined,
          errorCode: undefined
        }
      };

    case BenchmarkCurvesActionTypes.LoadCurvesSuccess:
      return {
        ...state,
        single: {
          ...state.single,
          date: action.payload.date,
          provider: action.payload.provider,
          data: action.payload.data,
          loading: false,
          loaded: true,
          error: undefined,
          errorCode: undefined
        }
      };

    case BenchmarkCurvesActionTypes.LoadWeeklyCurvesSuccess:
      return {
        ...state,
        weekly: {
          ...state.weekly,
          date: action.payload.date,
          provider: action.payload.provider,
          data: action.payload.data,
          loading: false,
          loaded: true,
          error: undefined,
          errorCode: undefined
        }
      };

    case BenchmarkCurvesActionTypes.LoadCurvesFail:
      return {
        ...state,
        single: {
          ...state.single,
          loading: false,
          error: action.payload.error,
          errorCode: action.payload.errorCode
        }
      };

    case BenchmarkCurvesActionTypes.LoadWeeklyCurvesFail:
      return {
        ...state,
        weekly: {
          ...state.weekly,
          loading: false,
          error: action.payload.error,
          errorCode: action.payload.errorCode
        }
      };

    case BenchmarkCurvesActionTypes.SelectCurve:
      return {
        ...state,
        selectedCurve: action.payload
      };

    default:
      return state;
  }
}
